export { default } from "@/app/p/[shareKey]"
